var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlueEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 8.625C13.4167 8.625 5.23258 14.5858 1.91675 23C5.23258 31.4142 13.4167 37.375 23.0001 37.375C32.5834 37.375 40.7676 31.4142 44.0834 23C40.7676 14.5858 32.5834 8.625 23.0001 8.625ZM23.0001 32.5833C17.7101 32.5833 13.4167 28.29 13.4167 23C13.4167 17.71 17.7101 13.4167 23.0001 13.4167C28.2901 13.4167 32.5834 17.71 32.5834 23C32.5834 28.29 28.2901 32.5833 23.0001 32.5833ZM23.0001 17.25C19.8184 17.25 17.2501 19.8183 17.2501 23C17.2501 26.1817 19.8184 28.75 23.0001 28.75C26.1817 28.75 28.7501 26.1817 28.7501 23C28.7501 19.8183 26.1817 17.25 23.0001 17.25Z",
    fill: "#122D58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlueEye);
export default __webpack_public_path__ + "static/media/icon-blue-eye.6d2028a96d03c52cd01f1bcd9bbef82f.svg";
export { ForwardRef as ReactComponent };